export default __webpack_public_path__ + "static/media/Reels-Preview-svg.a4c7fd9f.png";